import { Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as Sentry from "@sentry/react";
import Home from "./pages/Home";
import VehiclePage from "./pages/VehiclePage";
import NewVehicles from "./pages/NewVehicles";
import NewVehiclesBrands from "./pages/NewVehiclesBrands";
import FindVehicles from "./pages/FindVehicles";
import React from "react";
import Showrooms from "./pages/Showrooms";
import SingleServiceCenter from "./pages/SingleServiceCenter";
import SingleShowroom from "./pages/SingleShowroom";
import Wishlist from "./pages/Wishlist";
import Compare from "./pages/Compare";
import Sign from "./pages/Sign";
import ContactUs from "./pages/ContactUs";
import SellVehicle from "./pages/SellVehicle";
import Profile from "./pages/Profile";
import SingleNews from "./pages/SingleNews";
import News from "./pages/News";
import MyVehicles from "./pages/MyVehicles";
import { vehicleModules, vehicleConditions } from "./utils/GeneralTypes";
import VehiclesSearch from "./pages/VehiclesSearch";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// @note this router implementation is for sentry with react-router-dom v5 if we upgraded don't forget to update it
// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);
export const history = createBrowserHistory();

// TODO: add 404 page
// TODO: i don't think the routes are defined in the recomended way, please either check the docs for react-router-domv5 or better upgrade to v6!
const Routes = () => {
  return (
    <>
      {/****************************/}
      {/********* News **********/}
      {/****************************/}
      <SentryRoute exact path={`/news/:blogID`} component={SingleNews} />
      <SentryRoute exact path={`/news`} component={News} />

      {/****************************/}
      {/********* Profile **********/}
      {/****************************/}
      <SentryRoute exact path={`/profile`} component={Profile} />

      {/****************************/}
      {/********** Sign ************/}
      {/****************************/}
      <SentryRoute exact path={`/sign`} component={Sign} />

      {/****************************/}
      {/******* Sell Vehicle *******/}
      {/****************************/}
      {vehicleModules.map((module, index) => (
        <SentryRoute
          key={`sellvehicle${index}${module.single}`}
          exact
          path={`/sell-vehicle/${module.single}`}
          render={() => <SellVehicle isEditing={false} vehicleNames={module} />}
        />
      ))}
      <SentryRoute exact path="/sell-vehicle" render={() => <Redirect to="/sell-vehicle/bus" />} />

      {/****************************/}
      {/********* Compare **********/}
      {/****************************/}
      {vehicleModules.map((module, indexTop) =>
        vehicleConditions.map((state, index) => (
          <SentryRoute
            key={`compare${indexTop}${index}`}
            exact
            path={`/compare/${module.plural}/${state}`}
            render={() => <Compare vehicleNames={module} vehicleState={state} />}
          />
        )),
      )}
      <SentryRoute exact path="/compare" render={() => <Redirect to="/compare/buses/new" />} />

      {/****************************/}
      {/******* My Vehicles ********/}
      {/****************************/}
      {vehicleModules.map((module, index) => (
        <SentryRoute
          key={`editmyVehicles${index}${module.single}`}
          exact
          path={`/my-vehicles/${module.plural}/edit/:vehicleID`}
          render={() => <SellVehicle isEditing={true} vehicleNames={module} />}
        />
      ))}
      {vehicleModules.map((module, index) => (
        <SentryRoute
          key={`myVehicles${index}${module.single}`}
          exact
          path={`/my-vehicles/${module.plural}`}
          render={() => <MyVehicles vehicleNames={module} />}
        />
      ))}
      <SentryRoute exact path="/my-vehicles" render={() => <Redirect to="/my-vehicles/buses" />} />

      {/****************************/}
      {/********* Wishlist *********/}
      {/****************************/}
      {vehicleModules.map((module, indexTop) =>
        vehicleConditions.map((state, index) => (
          <SentryRoute
            key={`wishlist${indexTop}${index}`}
            exact
            path={`/wishlist/${module.plural}/${state}`}
            render={() => <Wishlist vehicleNames={module} vehicleState={state} />}
          />
        )),
      )}
      <SentryRoute exact path="/wishlist" render={() => <Redirect to="/wishlist/buses/new" />} />

      {/****************************/}
      {/***** Service Centers ******/}
      {/****************************/}
      <SentryRoute exact path="/service-centers/center/:centerID" render={() => <SingleServiceCenter />} />
      {vehicleModules.map((vehicleModule, index) => (
        <SentryRoute
          exact
          key={`serviceCenters${index}${vehicleModule}`}
          path={`/service-centers/${vehicleModule.plural}`}
          render={() => <Showrooms vehicleModule={vehicleModule} isServiceCenter={true} />}
        />
      ))}
      <SentryRoute
        exact
        path={`/service-centers`}
        render={() => <Redirect to={`/service-centers/${vehicleModules[0].plural}`} />}
      />

      {/****************************/}
      {/********* Showrooms ********/}
      {/****************************/}
      {/* {vehicleModules.map((module, indexTop) =>
        vehicleConditions.map((state, index) => (
          <React.Fragment key={`showrooms${indexTop}${index}`}>
            {state === "new" && (
              <SentryRoute
                exact
                path={`/showrooms/showroom/:centerID/${module.plural}/new/brand/:brandID`}
                render={() => <SingleShowroom vehicleNames={module} vehicleState={state} isBrandPage={true} />}
              />
            )}
            <SentryRoute
              exact
              path={`/showrooms/showroom/:centerID/${module.plural}/${state}`}
              render={() => <SingleShowroom vehicleNames={module} vehicleState={state} />}
            />
          </React.Fragment>
        )),
      )} */}
      <SentryRoute
        exact
        path="/showrooms/showroom/:centerID"
        // render={(routerProps) => <Redirect to={`/showrooms/showroom/${routerProps.match.params.centerID}/buses/new`} />}
        render={() => <SingleShowroom />}
      />
      {vehicleModules.map((vehicle, index) => (
        <SentryRoute
          exact
          key={`showrooms${index}${vehicle.single}`}
          path={`/showrooms/${vehicle.plural}`}
          render={() => <Showrooms vehicleModule={vehicle} />}
        />
      ))}
      <SentryRoute
        exact
        path={`/showrooms`}
        render={() => <Redirect to={`/showrooms/${vehicleModules[0].plural}`} />}
      />

      {/****************************/}
      {/********* Distributor *********/}
      {/****************************/}
      {vehicleModules.map((module, indexTop) => (
        <React.Fragment key={`distributor${indexTop}${module.single}`}>
          <SentryRoute
            key={indexTop + module.single + "dis"}
            exact
            path={`/distributor/${module.plural}`}
            render={() => <NewVehicles vehicleNames={module} />}
          />
          <SentryRoute
            key={indexTop + module.single + "disBrand"}
            exact
            path={`/distributor/${module.plural}/brands/:brandID`}
            render={() => <NewVehiclesBrands vehicleNames={module} />}
          />
          <SentryRoute
            key={indexTop + module.single + "disBrandVeh"}
            exact
            path={`/distributor/${module.plural}/${module.single}/:vehicleID`}
            render={() => <VehiclePage vehicleCondition={"new"} vehicleNames={module} isForDistributor={true} />}
          />

          <SentryRoute
            key={indexTop + module.single + "disBrandVehFind"}
            exact
            path={`/distributor/${module.plural}/find`}
            render={() => <FindVehicles vehicleCondition={"new"} vehicleNames={module} isForDistributor />}
          />
        </React.Fragment>
      ))}

      {/* <SentryRoute exact path={`/vehicles/search`} render={() => <VehiclesSearch />} /> */}

      {/****************************/}
      {/********* Vehicles *********/}
      {/****************************/}
      {vehicleModules.map((module, indexTop) =>
        vehicleConditions.map((vehicleCondition, index) => (
          <React.Fragment key={`vehicles${indexTop}${index}`}>
            <SentryRoute
              exact
              path={`/${vehicleCondition}-${module.plural}/find`}
              render={() => (
                <FindVehicles
                  vehicleCondition={vehicleCondition}
                  vehicleNames={module}
                  isForDistributor={vehicleCondition === "new"}
                />
              )}
            />
            <SentryRoute
              exact
              path={`/${vehicleCondition}-${module.plural}/${module.single}/:vehicleID`}
              render={() => (
                <VehiclePage
                  vehicleCondition={vehicleCondition}
                  vehicleNames={module}
                  isImported={vehicleCondition === "imported"}
                />
              )}
            />
          </React.Fragment>
        )),
      )}

      {/**************************/}
      {/********** HOME **********/}
      {/**************************/}
      <SentryRoute exact path="/" component={Home} />
      <SentryRoute exact path="/privacy-policy" component={PrivacyPolicy} />

      {/****************************/}
      {/********* Contact **********/}
      {/****************************/}
      <SentryRoute exact path={`/contact`} component={ContactUs} />
    </>
  );
};

export default Routes;
